<template>
  <div>
    <!-- dialog horario invalido -->
    <v-dialog
      v-model="event.date_invalid_dialog"
      persistent
      max-width="290"
    >
      <v-card>
        <v-card-title class="text-h5">
          Horário do evento não compativel!
        </v-card-title>
        <v-card-text>O horário informado é inválido.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="closeDialog()"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- fim dialog horario invalido -->
    <default-card class="mt-3 pb-2">
      <template slot="title-left">
        <span v-if="$route.name == 'ShowEvent'"> {{ event.category == 'block_calendar' ? 'Bloqueio de agenda' : 'Dados do evento' }} </span>
        <span v-if="$route.name == 'NewEvent'"> Adicionar evento </span>
        <span v-if="$route.name == 'NewNegotiation'"> Adicionar negociação </span>
        <span v-if="$route.name == 'NewScheduleLock'"> Bloquear agenda </span>
        📝 
      </template>
      <template slot="title-right"> 
        
        <div v-if="event.category == 'event'">
          <v-btn @click="enableEditing()" text small
            :color="!is_editing ? 'normal' : 'red'" 
            class="btn-primary"
            :disabled="loading"
            v-if="is_component_show_event && !is_editing"
          ><v-icon left>mdi-pencil</v-icon>{{!is_editing ? 'Editar' : 'Cancelar'}}</v-btn> 
        </div>

        <div v-if="event.category == 'block_calendar'">
          <v-btn 
            @click="enableEditing()" text small
            color="normal" 
            class="btn-primary"
            :disabled="loading"
            v-if="!is_editing"
          ><v-icon left>mdi-pencil</v-icon>Editar</v-btn>
        </div>

      </template>
      <template slot="content">

        <card-loading-transparent v-if="loading"></card-loading-transparent>
        <show-event-infos
          v-if="is_editing == false && !loading && $route.name == 'ShowEvent'"
          :event="event"
          :event_details="event_detail_attributes"
          :event_contact="event_contact_attributes"
        ></show-event-infos>
        <v-card outlined v-if="is_editing == true && !loading && $route.name == 'ShowEvent'">
          <v-card-text>

            <edit-event-infos
              v-if="event.category == 'event'"
              class="mt-n6"
              :event_to_edit="event"
              :event_detail_attributes_to_edit="event_detail_attributes"
              :event_contact_attributes_to_edit="event_contact_attributes"
              @updateEvent="updateEvent"
              @cancelEditing="cancelEditing"
              @createEvent="createEvent"
              :is_component_show_event="is_component_show_event"
              :is_component_create_event="is_component_create_event"
            ></edit-event-infos>

            <div v-if="event.category == 'block_calendar'">
              <EditScheduleBlock v-if="!loading" :event="event" :is_editing="is_editing" @cancelEditing="cancelEditing"></EditScheduleBlock>
            </div>

          </v-card-text>
        </v-card>
        <v-card outlined v-if="menu_add_permmited_routes">
          <v-card-text class="px-0">
            <create-event-infos @createEvent="createEvent"></create-event-infos>
          </v-card-text>
        </v-card>

      </template>
      <template slot="actions"> </template>
    </default-card>
    
    <dialog-loading v-if="saving"></dialog-loading>
  </div>
</template>

<script>
  import validations from "@/mixins/validations";
  import { mapState, mapActions } from 'vuex';
  import {CurrencyDirective} from 'vue-currency-input';
  import cep from 'cep-promise'
  import Api from '@/api'

  export default {
    name: 'FormEventInfo',
    mixins: [ validations ],
    directives: {
      currency: CurrencyDirective,
    },
    props: {
      is_component_show_event: {
        type: Boolean
      },
      is_component_create_event: {
        type: Boolean
      },
    },
    components: {
      ShowEventInfos: () => import ('./event_infos/ShowEventInfos.vue'),
      EditEventInfos: () => import ('./event_infos/EditEventInfos.vue'),
      CreateEventInfos: () => import ('./event_infos/CreateEventInfos.vue'),
      EditScheduleBlock: () => import ('./event_infos/EditScheduleBlock.vue'),
    },
    data() {
      return {
        total_value: 0,
        loading: false,
        saving: false,
        dialog_color_picker: false,
        is_editing: this.is_component_show_event ? false : this.is_component_create_event ? true : '',
        is_event_end_after_start: false,
        date_invalid_dialog: false,
        event: {
          name: '',
          status: '',
          category: '',
          start_at: '',
          end_at: '',
          start_time: '',
          end_time: '',
          color: '',
          value: '',
        },
        event_detail_attributes: {
          size: '',
          zip: '', 
          address: '',
          description: '',
          place: '',
          city: '',
          district: '',
          state: '',
          address_number: '',
          country: '',
          street: '',
        },
        event_contact_attributes: {
          responsible_name: '',
          responsible_phone: '',
          responsible_email: '',
          responsible_kind: ''
        },
        valid: true,
      }
    },
    mounted() {
      this.getData()
    },
    methods: {
      prepareEvent(ev, ev_detail, ev_contact){
        let event = {
          ...ev,
          value: Math.round(Number(ev.value.replace(/,/g, '') )*100),
          event_detail_attributes: {
            ...ev_detail
          },
          event_contact_attributes: {
            ...ev_contact
          }
        }
        return event
      },
      updateEvent(ev, ev_detail, ev_contact){
        this.loading = true
        this.is_editing = !this.is_editing
        let event = this.prepareEvent(ev, ev_detail, ev_contact)
        Api.Event.update(event).then(r=>r.data).then(d=>{
          this.event = {
            ...d,
            value: (d.value / 100).toString(),
            start_time: d.start_time ? this.$dayjs(d.start_time).add(3, 'hour').format('HH:mm') : null,
            end_time: d.end_time ? this.$dayjs(d.end_time).add(3, 'hour').format('HH:mm') : null,
          }
        }).catch(err=>{
          console.log(err);
        }).finally(async ()=>{
          await this.getEventDetails(this.event.id)
          this.$emit('setEvent', {...this.event})
          setTimeout(()=>{
            this.loading = false
          },600)
        })
      },
      createEvent(ev, ev_detail){
        this.loading = true
        let event = this.prepareEvent(ev, ev_detail)
        Api.Event.create({...event, company_id: this.activeCompanyId}).then((r)=>{
          this.$router.push({name: 'ShowEvent', params: {id: r.data.id}})
        }).catch(err=>{
          console.log(err)
        }).finally(()=>{
          this.getData()
        })
      },
      getData(){
        if(this.$route.params.id){
          let id = this.$route.params.id
          this.loading = true
          Api.Event.show(id).then(r=>r.data).then((d)=>{
            this.event = {
              ...d,
              value: (d.value / 100).toString(),
              start_time: d.start_time ? this.$dayjs(d.start_time).add(3, 'hour').format('HH:mm') : null,
              end_time: d.end_time ? this.$dayjs(d.end_time).add(3, 'hour').format('HH:mm') : null,
            }
          }).catch(err=>{
            console.log({err});
            if (err.response && err.response.status == '404'){
              alert('Esse registro não existe ou você não tem acesso.')
              this.$router.go(-1)
            }
          }).finally(async ()=>{
            await this.getEventDetails(id)
            await this.getEventContact(id)
            this.$emit('setEvent', {...this.event})
            this.commitEvent({...this.event})
            setTimeout(()=>{
              this.loading = false
            },1200)
          })
        }
      },
      async getEventDetails(event_id){
        let data = {}
        return await Api.EventDetail.indexByEvent({event_id: event_id}).then(r=>r.data).then(d=>{
          data = d
        }).catch(err=>{
          console.log(err);
        }).finally(()=>{
          this.event_detail_attributes = {
            ...data
          }
        })
      },
      async getEventContact(event_id){
        let data = {}
        return await Api.EventContact.indexByEvent({event_id: event_id}).then(r=>r.data).then(d=>{
          data = d
        }).catch(err=>{
          console.log(err);
        }).finally(()=>{
          this.event_contact_attributes = {
            ...data
          }
        })
      },
      cancelEditing(){
        this.is_editing = !this.is_editing
        this.getData()
      },
      closeDialog(){
        this.date_invalid_dialog = false
      },
      enableEditing(){
        this.is_editing = !this.is_editing
      },
      ...mapActions({
        commitEvent: 'Event/commitEvent',
        commitStepper: 'Event/commitStepper',
        update: 'Event/update',
      }),
    },
    computed: {
      menu_add_permmited_routes(){
        return ['NewEvent', 'NewNegotiation', 'NewScheduleLock'].includes(this.$route.name) 
      },
      can_advance(){
        return this.valid && this.is_event_end_after_start && this.is_job_end_after_start && this.is_event_end_after_job_end && this.is_event_start_before_job_start
      },
      ...mapState({
        event_info: state => state.Event.event_info,
        base_event: state => state.Event.base_event, 
        activeCompanyId: state => state.App.activeCompanyId
      }),
    },

  }
</script>

<style lang="scss" scoped>

</style>